module.exports = __webpack_public_path__ + "img/vk.0ceb12f8.svg";